module.exports = __webpack_public_path__ + "bottom.25ce60a6.png";